import { ORG_TYPE_LIBRARY, ORG_TYPE_RURAL_HOSPITAL } from 'src/common/Constants';
import { AgentVerificationState } from 'src/state/agent-verification/types';
import { IFeatureFlagsState } from 'src/state/feature-flags';
import { IAgentEmailVerification, INonprofitState, NonprofitStatus } from 'src/state/nonprofit';
import { IProfile } from 'src/state/profile/types';

export function isEmailVerificationRequired(nonprofit: INonprofitState, agentVerification: AgentVerificationState) {
  return (
    nonprofit.miniProfile &&
    ((nonprofit.miniProfile.status === NonprofitStatus.InProgress &&
      nonprofit.miniProfile.emailVerified === IAgentEmailVerification.No) ||
      (nonprofit.miniProfile.status === NonprofitStatus.Approved &&
        nonprofit.miniProfile.emailVerified !== IAgentEmailVerification.Yes)) &&
    !agentVerification.isTokenVerificationSuccess
  );
}

export function mungeEmailAddress(s?: string | null) {
  if (!s) return '';
  const i = s.indexOf('@');
  // eslint:disable-next-line: no-bitwise
  const startIndex = (i * 0.2) | 0;
  // eslint:disable-next-line: no-bitwise
  const endIndex = (i * 0.9) | 0;

  return s.slice(0, startIndex) + s.slice(startIndex, endIndex).replace(/./g, '*') + s.slice(endIndex);
}

export function isNonprofitValidationRequired(
  formInitialValues: Partial<IProfile>,
  formValues: IProfile,
  featureFlags: IFeatureFlagsState
) {
  const sortKey = 'identifierKey';
  const legalId = 'legalIdentifier';
  if (formInitialValues === undefined || formValues === undefined) {
    return false;
  }

  const sortedInitialIdentifiers = getSortedValues(formInitialValues.registrationIdentifiers, sortKey);
  const sortedIdentifiers = getSortedValues(formValues.registrationIdentifiers, sortKey);
  const hasEqualIdentifiers = sortedInitialIdentifiers.every(
    (identifier, index) =>
      sortedIdentifiers[index] &&
      sortedIdentifiers[index][legalId] == identifier[legalId] &&
      sortedIdentifiers[index][sortKey] == identifier[sortKey]
  );

  const initialDocuments = formInitialValues.documents;
  const documents = formValues.documents;
  const documentsChanged =
    initialDocuments !== documents &&
    (!initialDocuments ||
      !documents ||
      initialDocuments.length !== documents.length ||
      initialDocuments.some(
        (initialDocument, index) =>
          initialDocument.id !== documents[index].id || initialDocument.name !== documents[index].name
      ));

  return (
    formInitialValues !== undefined &&
    formValues !== undefined &&
    (formInitialValues.name !== formValues.name ||
      formInitialValues.address?.countryCode !== formValues.address?.countryCode ||
      (!featureFlags.profilePageEnhancementsEnabled && formInitialValues.address?.city !== formValues.address?.city) ||
      (!!formInitialValues.organizationType && formInitialValues.organizationType !== formValues.organizationType) ||
      (!formInitialValues.organizationType &&
        (formValues.organizationType === ORG_TYPE_LIBRARY ||
          formValues.organizationType === ORG_TYPE_RURAL_HOSPITAL)) ||
      !hasEqualIdentifiers ||
      documentsChanged)
  );
}

export function getSortedValues(object: any, sortKey: string) {
  const list: any[] = Object.values(object);

  return list.sort((a, b) => {
    let x = a[sortKey];
    let y = b[sortKey];

    return x < y ? -1 : x > y ? 1 : 0;
  });
}
